import { Link } from 'react-router-dom';
import { DashboardGate } from './DashboardGate';
import { DashboardLayout } from './DashboardSidebar';

/**
 * MD-27 Admin Dashboard Hub - F-A-DASHBOARD-HUB
 *
 * Entry point /dashboard/ liet ke moi cong cu quan tri Asklaw.
 * Day-1 chi co MD-26 Social Insight LIVE. PLANNED card disabled.
 *
 * Spec: specs/domains/admin/F-A-DASHBOARD-HUB.md
 * Auth gate: reuse DashboardGate (JWT tier='admin').
 */

interface DashboardCard {
  path: string;
  title: string;
  description: string;
  status: 'LIVE' | 'PLANNED';
  module: string;
}

// Patch 2026-05-12 (DECISIONS s2026-05-12-HUB-PRUNE-MD26-MERGE-MD29):
// - BO MD-26 Social Insight standalone (merged vao MD-29 tab Social).
// - AN MD-24 News Pipeline (overlap MD-28 cron view) va MD-9 Doc Pack admin (chua launch Phase 0).
// - GIU 3 PLANNED roadmap critical: MD-25 SEO, MD-COST Chi phi, MD-15 Eval gold-50.
const CARDS: DashboardCard[] = [
  {
    path: '/dashboard/agents',
    title: 'Agents + Cron',
    description:
      '7 agent dinh nghia va 11 cron job: theo doi schedule, lan chay cuoi, nhat ky hoat dong 48h.',
    status: 'LIVE',
    module: 'MD-28',
  },
  {
    path: '/dashboard/content',
    title: 'Quan ly noi dung',
    description:
      'Theo doi 36+ bai blog va post FB Page (kem Social Insight reach va brief Mon/Thu): trang thai, cluster, citation, canh bao UPL.',
    status: 'LIVE',
    module: 'MD-29',
  },
  {
    path: '/dashboard/seo',
    title: 'SEO Bootstrap',
    description:
      'Theo doi 4 cron SEO + IndexNow + GSC URL Inspection, sitemap freshness, kiem tra schema, lien ket noi bo.',
    status: 'LIVE',
    module: 'MD-25',
  },
  {
    path: '/dashboard/cost',
    title: 'Chi phi ha tang',
    description:
      'Cloudflare D1, KV, R2, Vectorize cong voi chi phi Gemini token theo ngay.',
    status: 'PLANNED',
    module: 'MD-COST',
  },
  {
    path: '/dashboard/eval',
    title: 'Eval gold-50',
    description:
      'Citation accuracy, refusal rate, drift theo phien ban prompt va corpus.',
    status: 'PLANNED',
    module: 'MD-15',
  },
];

function StatusBadge({ status }: { status: 'LIVE' | 'PLANNED' }) {
  const label = status === 'LIVE' ? 'Dang chay' : 'Sap ra mat';
  const cls =
    status === 'LIVE'
      ? 'dashboard-hub-badge dashboard-hub-badge-live'
      : 'dashboard-hub-badge dashboard-hub-badge-planned';
  return <span className={cls}>{label}</span>;
}

function CardLive({ card }: { card: DashboardCard }) {
  return (
    <Link to={card.path} className="dashboard-hub-card dashboard-hub-card-live">
      <div className="dashboard-hub-card-head">
        <h3 className="dashboard-hub-card-title">{card.title}</h3>
        <StatusBadge status={card.status} />
      </div>
      <p className="dashboard-hub-card-desc">{card.description}</p>
      <div className="dashboard-hub-card-foot">
        <span className="dashboard-hub-card-module">{card.module}</span>
        <span className="dashboard-hub-card-cta">Mo cong cu &raquo;</span>
      </div>
    </Link>
  );
}

function CardPlanned({ card }: { card: DashboardCard }) {
  return (
    <div
      className="dashboard-hub-card dashboard-hub-card-planned"
      aria-disabled="true"
      role="group"
    >
      <div className="dashboard-hub-card-head">
        <h3 className="dashboard-hub-card-title">{card.title}</h3>
        <StatusBadge status={card.status} />
      </div>
      <p className="dashboard-hub-card-desc">{card.description}</p>
      <div className="dashboard-hub-card-foot">
        <span className="dashboard-hub-card-module">{card.module}</span>
        <span className="dashboard-hub-card-cta-disabled">Chua mo</span>
      </div>
    </div>
  );
}

function HubInner() {
  const live = CARDS.filter((c) => c.status === 'LIVE');
  const planned = CARDS.filter((c) => c.status === 'PLANNED');

  return (
    <main className="dashboard-shell dashboard-hub">
      <header className="dashboard-hub-header">
        <h1 className="dashboard-hub-title">Bang dieu khien quan tri</h1>
        <p className="dashboard-hub-sub">
          Tap hop cong cu noi bo cho admin Asklaw. Chon mot the de mo cong cu tuong ung.
        </p>
      </header>

      <section className="dashboard-hub-section">
        <h2 className="dashboard-hub-section-title">Dang chay ({live.length})</h2>
        <div className="dashboard-hub-grid">
          {live.map((c) => (
            <CardLive key={c.path} card={c} />
          ))}
        </div>
      </section>

      <section className="dashboard-hub-section">
        <h2 className="dashboard-hub-section-title">Sap ra mat ({planned.length})</h2>
        <div className="dashboard-hub-grid">
          {planned.map((c) => (
            <CardPlanned key={c.path} card={c} />
          ))}
        </div>
      </section>

      <footer className="dashboard-hub-footer">
        <p>
          Phien ban Phase 0 - chi danh cho founder va admin. Du lieu noi bo, khong
          xuat ra nguoi dung cuoi.
        </p>
      </footer>
    </main>
  );
}

export function DashboardHubRoute() {
  return (
    <DashboardGate>
      <DashboardLayout>
        <HubInner />
      </DashboardLayout>
    </DashboardGate>
  );
}
